import { DriverDayOffsService } from '@/backend/market'
import { PaginateEntity } from '@/shared/entities/PaginateEntity'
import type { DriverDayOffEntity } from '../../domain/entities/DriverDayOffEntity'
import type { DriverDayOffFilterEntity } from '../../domain/entities/DriverDayOffFilterEntity'
import type { PostDriverDayOffEntity } from '../../domain/entities/PostDriverDayOffEntity'
import type { ReviewDriverDayOffEntity } from '../../domain/entities/ReviewDriverDayOffEntity'
import { DriverDayOffRepository } from '../../domain/repositories/DriverDayOffRepository'
import { DriverDayOffFilterModel } from '../models/DriverDayOffFilterModel'
import { DriverDayOffModel } from '../models/DriverDayOffModel'
import { PostDriverDayOffModel } from '../models/PostDriverDayOffModel'
import { ReviewDriverDayOffModel } from '../models/ReviewDriverDayOffModel'

export class DriverDayOffRepositoryImpl implements DriverDayOffRepository {
  async getDriverDayOff(id: string): Promise<DriverDayOffEntity | { error: true }> {
    try {
      const response = await DriverDayOffsService.getDriverDayOffAdmin({ id })
      return new DriverDayOffModel(response)
    } catch {
      return { error: true }
    }
  }

  async getDriverDayOffs(
    filterData: DriverDayOffFilterEntity
  ): Promise<PaginateEntity<DriverDayOffEntity[]> | { error: true }> {
    const driverDayOffFilterModel = new DriverDayOffFilterModel(filterData)

    try {
      const response = await DriverDayOffsService.getDriverDayOffsAdmin(driverDayOffFilterModel)
      const driverDayOffModels = response.items?.map((item) => new DriverDayOffModel(item))
      return new PaginateEntity<DriverDayOffEntity[]>(response, driverDayOffModels)
    } catch {
      return { error: true }
    }
  }

  async createDriverDayOff(
    data: PostDriverDayOffEntity
  ): Promise<DriverDayOffEntity | { error: true }> {
    const requestModel = new PostDriverDayOffModel(data)

    try {
      const response = await DriverDayOffsService.postDriverDayOffAdmin({
        requestBody: requestModel
      })
      return new DriverDayOffModel(response)
    } catch {
      return { error: true }
    }
  }

  async approveDriverDayOff(
    id: string,
    data: ReviewDriverDayOffEntity
  ): Promise<DriverDayOffEntity | { error: true }> {
    const requestModel = new ReviewDriverDayOffModel(data)

    try {
      const response = await DriverDayOffsService.postApproveDriverDayOffAdmin({
        id,
        requestBody: requestModel
      })
      return new DriverDayOffModel(response)
    } catch {
      return { error: true }
    }
  }

  async rejectDriverDayOff(
    id: string,
    data: ReviewDriverDayOffEntity
  ): Promise<DriverDayOffEntity | { error: true }> {
    const requestModel = new ReviewDriverDayOffModel(data)

    try {
      const response = await DriverDayOffsService.postRejectDriverDayOffAdmin({
        id,
        requestBody: requestModel
      })
      return new DriverDayOffModel(response)
    } catch {
      return { error: true }
    }
  }

  async completeDriverDayOff(id: string): Promise<DriverDayOffEntity | { error: true }> {
    try {
      const response = await DriverDayOffsService.postCompleteDriverDayOffAdmin({ id })
      return new DriverDayOffModel(response)
    } catch {
      return { error: true }
    }
  }

  async cancelDriverDayOff(id: string): Promise<DriverDayOffEntity | { error: true }> {
    try {
      const response = await DriverDayOffsService.postCancelDriverDayOffAdmin({ id })
      return new DriverDayOffModel(response)
    } catch {
      return { error: true }
    }
  }
}
